import React, { createContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import translationManager from '../../API/translationManager';
import { getMe } from '../../API/repositories/user';
import { LOGIN_PATH } from '../../API/constants/auth';
import { CONSULTANT_ROLES } from '../constants/consultantRoles';
import { ALL_ACCESSES } from '../constants/allAccesses';
import { ACCESSES } from '../constants/accesses';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [authUser, setAuthUser] = useState();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const checkAccess = (access) => {
		if (!authUser) {
			return false;
		}

		const isAdmin = authUser.role === 'ADMIN';
		if (isAdmin) {
			return true;
		}

		return authUser.access?.includes(access);
	};

	const getAllAcesses = () => ALL_ACCESSES;

	const getRolesAccesses = (role) => ACCESSES[role];

	useEffect(() => {
		const bootstrapSession = async () => {
			const response = await getMe();
			const user = response.data;

			if (!user) {
				const isAlreadyOnLogin = pathname === LOGIN_PATH;
				if (!isAlreadyOnLogin) {
					navigate(LOGIN_PATH);
				}
				setAuthUser(null);
				return;
			}

			setAuthUser(user);
			translationManager.getLanguage(user.id);

			if (pathname === '/') {
				const isConsultant = CONSULTANT_ROLES.includes(user.role);
				const nextPath = isConsultant
					? '/consultant/dashboard'
					: '/dashboard';
				navigate(nextPath);
			}
		};

		bootstrapSession();
	}, []);

	return (
		<AuthContext.Provider
			value={{
				authUser,
				setAuthUser,
				checkAccess,
				getAllAcesses,
				getRolesAccesses,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
